export default __webpack_public_path__ + "static/media/change-link-img-cn.e2b5c91a.svg";